import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

interface ProfitabilityChartSkeletonProps {}

export const ProfitabilityChartSkeleton: React.FC<ProfitabilityChartSkeletonProps> = () => {
  return (
    <VStack space={Spacing['inline.xxs']} w="full">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index.toString()}
            w={'full'}
            maxW={'57px'}
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.md}
            endColor={Color['brand.primary.lightest']}
          />
        ))}
      </HStack>
      <Skeleton
        w={'full'}
        h={'268px'}
        borderRadius={BoxRadius.md}
        endColor={Color['brand.primary.lightest']}
      />
      <HStack
        space={Spacing['inline.nano']}
        alignItems="center"
        justifyContent="space-between"
        w="full">
        <VStack space={Spacing['inline.quarck']}>
          <Skeleton
            w="32px"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.md}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="64px"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.md}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>

        <VStack space={Spacing['inline.quarck']}>
          <Skeleton
            w="32px"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.md}
            endColor={Color['brand.primary.lightest']}
          />
          <HStack alignItems="center" space={Spacing['inline.nano']}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                key={index.toString()}
                w="32px"
                h={Typography['fontsize.lg']}
                borderRadius={BoxRadius.md}
                endColor={Color['brand.primary.lightest']}
              />
            ))}
          </HStack>
        </VStack>
      </HStack>
    </VStack>
  );
};
